import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { pageAnimation } from '@app/shared/animations/page-animations';
import { Device } from '@app/shared/models/device';
import { Preview } from '@app/shared/models/preview';
import { TransferFile } from '@app/shared/models/transferFile';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ViewerActions } from '../actions';
import * as fromViewer from '../reducers/viewer.reducer';

export enum KEY_CODE {
  ESCAPE = 27,
}
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  animations: [
    pageAnimation
  ]
})
export class PreviewComponent implements OnInit {

  @Input() preview: Preview;
  @Input() device: Device;
  @Input() files: TransferFile[];
  @Input() selectedFiles: TransferFile[];
  @Input() snackbarDisplayed: boolean;

  @Output() unscrollPreview: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedModalFile$: Observable<TransferFile>;

  constructor(private store$: Store<fromRoot.State & fromViewer.State>) {
    this.selectedModalFile$ = this.store$.select(fromViewer.getSelectedModalFile);
  }

  ngOnInit(): void { }

  closePreview() {
    this.unscrollPreview.emit(true);
  }

  downloadZip() {
    this.store$.dispatch(ViewerActions.RequestDownloadUrls({}));
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.ESCAPE) {
      this.closePreview();
    }
  }
}
